const omitKeys = (value, keys) => Object.fromEntries(
  Object.entries(value || {}).filter(([key]) => !keys.includes(key)),
);

const cloneArtwork = (artwork) => {
  if (!artwork || typeof artwork !== "object") return artwork;
  return omitKeys(artwork, [
    "id",
    "PromoStoreItemId",
    "PromoStoreItemDecorationId",
    "createdAt",
    "updatedAt",
    "PromoStoreItem",
    "PromoStoreItemDecoration",
  ]);
};

const cloneDecoration = (decoration = {}) => {
  const copy = omitKeys(decoration, [
    "id",
    "PromoStoreItemId",
    "createdAt",
    "updatedAt",
  ]);

  if (copy.ArtWork) copy.ArtWork = cloneArtwork(copy.ArtWork);
  if (copy.artWork) copy.artWork = cloneArtwork(copy.artWork);
  if (copy.artwork) copy.artwork = cloneArtwork(copy.artwork);
  return copy;
};

const clonePricing = (pricing = {}) => omitKeys(pricing, [
  "id",
  "PromoStoreItemId",
  "createdAt",
  "updatedAt",
]);

/**
 * Copies PromoStore configuration while deliberately dropping database identity.
 * ProductId/Id is catalog identity and remains shared; PromoStore item/child ids do not.
 */
export const clonePromoStoreProduct = (product = {}) => {
  const copy = omitKeys(product, [
    "id",
    "PromoStoreItemId",
    "promoStoreItemId",
    "itemId",
    "ItemId",
    "cartLineId",
    "createdAt",
    "updatedAt",
  ]);

  if (copy.StorefrontPricingRules && typeof copy.StorefrontPricingRules === "object") {
    copy.StorefrontPricingRules = JSON.parse(JSON.stringify(copy.StorefrontPricingRules));
  }
  if (copy.storefrontPricingRules && typeof copy.storefrontPricingRules === "object") {
    copy.storefrontPricingRules = JSON.parse(JSON.stringify(copy.storefrontPricingRules));
  }

  if (Array.isArray(copy.pricings)) copy.pricings = copy.pricings.map(clonePricing);
  if (Array.isArray(copy.Pricings)) copy.Pricings = copy.Pricings.map(clonePricing);
  if (Array.isArray(copy.decorations)) copy.decorations = copy.decorations.map(cloneDecoration);
  if (Array.isArray(copy.Decorations)) copy.Decorations = copy.Decorations.map(cloneDecoration);

  return copy;
};
